import { registerValidator } from '../validatorRegistry';

registerValidator({
  key: 'color-profile',
  runsOn: ['upload'],
  async validate(ctx) {
    const mime = ctx.file?.type ?? '';
    if (mime === 'image/jpeg' || mime === 'image/jpg') {
      return {
        key: 'color-profile', status: 'warning', blocker: false,
        title: 'JPEG colour',
        message: 'JPEG images use sRGB. Printed colours may differ slightly from screen.',
        suggestion: 'For colour-accurate print, use PNG or SVG.',
      };
    }
    return { key: 'color-profile', status: 'pass', blocker: false, title: 'Colour', message: '' };
  },
});
